import { render, staticRenderFns } from "./TaskListIcon.vue?vue&type=template&id=46de47b8&scoped=true&"
import script from "./TaskListIcon.vue?vue&type=script&lang=js&"
export * from "./TaskListIcon.vue?vue&type=script&lang=js&"
import style0 from "./TaskListIcon.vue?vue&type=style&index=0&id=46de47b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46de47b8",
  null
  
)

export default component.exports